<template>
  <div class="container intro-section checkout-success center-page-content">
    <div class="row">
      <div class="col text-center">
        <Icon name="grCheckCircleBroken" width="36" class="mb-3"/>
        <h1 class="title">
          <template v-if="isBankTransferPayment">
             {{ $t('pages.checkout_success.title_bank_transfer') }}
          </template>
          <template v-else>
             {{ $t('pages.checkout_success.title') }}
          </template>
        </h1>

        <div v-if="!isBankTransferPayment">
          <router-link :to="{ name: 'checkins-list'}" class="btn btn-primary mt-4">
            {{ $t('pages.checkout_success.action_go_to_events') }}
          </router-link>
        </div>

        <div v-if="isBankTransferPayment" class="mt-5">
          <div class="font-weight-medium text-secondary mb-3">
            {{ $t('pages.checkout_success.bank_account_details') }}
          </div>

          <div class="bg-light table-w mb-3">
            <table class="table table-striped">
              <tbody>
              <tr class="" v-for="(item, index) in dataTableBankTransfer" :key="index">
                <td class="border-light text-left">{{item.label}}</td>
                <td class="border-light text-right">{{item.value}} <a href="#" @click.prevent="copy(item.value)"> <Icon class="ml-1" name="copy" width="20" /></a></td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="bg-light table-w">
            <table class="table">
              <tbody>
              <tr class="">
                <td class="border-light text-left">{{$t('pages.checkout_success.bank_account_amount')}}</td>
                <td class="border-light text-right">{{order.price_grandtotal|formatCurrency(order.currency)}}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="checkout-success__footer mt-2">
            <div>{{ $t('pages.checkout_success.bank_transfer_todo_1') }}
              <span class="">{{ $t('pages.checkout_success.bank_transfer_todo_2') }} <a :href="getContactUrl()">support@getpica.com</a></span>.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {PAYMENT_METHOD_BANK_TRANSFER} from "@/consts.js"
import CartService from "@/services/Cart.js"
import {getContactUrl} from "@/utils";

export default {
  props: {
    orderId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      order: {
        has_digital_items: true,
        has_print_items: true,
      },
    }
  },

  beforeMount() {
    window.scrollTo(0, 0);
  },

  mounted() {
    if (this.orderId) {
      CartService.getOrders({orderId: this.orderId})
          .then((response) => {
            this.order = response.data
          })
    } else {
      this.$set(this.order, 'order_number', '1111-22222-333333')
    }
  },

  computed: {
    isBankTransferPayment() {
      //return true
      return this.order.payment_method === PAYMENT_METHOD_BANK_TRANSFER
    },
    dataTableBankTransfer() {
      return [
        {
          label: this.$t('pages.checkout_success.bank_account_headed_to'),
          value: 'Pica Group SpA',
        },
        {
          label: 'IBAN',
          value: 'IT91T0538723602000002420952',
        },
        {
          label: 'SWIFT',
          value: 'BPMOIT22XXX',
        },
        {
          label: this.$t('pages.checkout_success.bank_account_reason_for_payment'),
          value: this.order.order_number,
        }
      ]
    }
  },

  methods: {
    getContactUrl,
    copy(value) {
      navigator.clipboard.writeText(value)
      this.$bvToast.toast(this.$t('notifications.text_copied'))
    }
  }
}
</script>
